import didomi from '@/scripts/didomi'

export default () => {
  const show = () => (window as any).Didomi.preferences.show()
   
  const isSameLanguage = (lang: string) => (window as any).Didomi.getLanguage() === lang

  const setDidomiLanguage = (lang: string) => {
    (window as any).didomiConfig = {
      languages: {
        enabled: [lang],
        default: lang,
      },
    }
  }
  const refresh = () => {
    (window as any).Didomi = undefined
    didomi()
  }

  return {
    show,
    isSameLanguage,
    refresh,
    setDidomiLanguage,
  }
}
